<div class="container" [ngSwitch]="mode">
  <div *ngSwitchDefault>
    <div *ngIf="isLoading" class="spinner">
      <mat-spinner></mat-spinner>
    </div>
    <table *ngIf="!isLoading" style="width: 100%">
      <ng-container *ngIf="!showComment">
        <tr class="back">
          <th>Name</th>
          <th>
            <input
              type="text"
              class="form-control"
              id="search-text"
              aria-describedby="search-text"
              [(ngModel)]="searchText"
              placeholder="Search"
              autofocus
            />
          </th>
          <th></th>
        </tr>
        <tr class="td" *ngFor="let emplyee of filterddata">
          <td>{{ emplyee.name }}</td>
          <td>{{ emplyee.Status }}</td>
          <td>
            <div class="dropdown">
              <button class="dropbtn" mat-raised-button>Actions</button>
              <div class="dropdown-content">
                <a class="dropdown-item" (click)="finalizerId(emplyee.id)"
                  >Finalizer</a
                >
                <a class="dropdown-item" (click)="initializerId(emplyee.id)"
                  >Initializer</a
                >
              </div>
            </div>
          </td>
        </tr>
      </ng-container>
      <ng-container *ngIf="showComment">
        <div style="padding: 20px">
          <mat-form-field>
            <mat-label>Comment</mat-label>
            <textarea [(ngModel)]="comment" matInput placeholder=""></textarea>
          </mat-form-field>
          <button
            mat-raised-button
            color="primary"
            (click)="overideFinializer()"
          >
            Submit
          </button>
        </div>
      </ng-container>
    </table>
    <div class="errorMessage">
      <div *ngIf="Errors" class="error">
        <p>{{ Errors }}</p>
      </div>
    </div>
    <div class="last"></div>
  </div>
</div>
